import { trackingPageBlockIds } from '@reveni-io/reveni-ui'

export const orderTrackingPageTabs = {
  layout: 'layout',
  visibilityCriteria: 'visibilityCriteria',
}

export const orderTrackingPageTabList = [
  { label: 'Layout', value: orderTrackingPageTabs.layout },
  { label: 'Criterios de visibilidad', value: orderTrackingPageTabs.visibilityCriteria },
]

export const previewViewModes = {
  mobile: 'mobile',
  desktop: 'desktop',
}

export const previewModes = {
  customScenario: 'customScenario',
  realOrder: 'realOrder',
}

export const previewModeOptions = [
  {
    id: previewModes.customScenario,
    label: 'Escenario personalizado',
    description: 'Previsualizando un pedido simulado. Los datos y ajustes de visibilidad son totalmente configurables.',
  },
  {
    id: previewModes.realOrder,
    label: 'Pedido real',
    description:
      'Previsualizando con datos de un pedido real. La página refleja la fecha actual y los criterios reales del cliente.',
  },
]

export const blockSettingFieldTypes = {
  boolean: 'boolean',
  translatedText: 'translatedText',
  text: 'text',
  image: 'image',
  color: 'color',
  textarea: 'textarea',
  number: 'number',
  select: 'select',
}

export const blockSettingOptionsSources = {
  productCategories: 'productCategories',
  productCollections: 'productCollections',
}

export const internalNameSettingKey = 'internal_name'

const promotionalBannerAspectRatioSetting = { key: 'aspect_ratio', min: 0.2, max: 10 }

export const maxRecommendedProducts = 10

export const previewRecommendedProductPrice = { base: 19.9, step: 10 }

const customPublicNameLabel = 'Usar un nombre público personalizado'

const customMessageLabel = 'Usar mensaje personalizado'

const internalNameField = {
  key: internalNameSettingKey,
  type: blockSettingFieldTypes.text,
  label: 'Nombre interno',
  required: true,
  defaultValue: '',
}

const blockInternalNameSection = {
  title: 'Título del bloque',
  description: 'Nombra este bloque para que tu equipo pueda identificarlo:',
  fields: [internalNameField],
}

export const editorBlockMetadata = {
  [trackingPageBlockIds.orderStatusCard]: {
    label: 'Estado del pedido',
    description:
      'Muestra el número de pedido, la fecha y el estado actual de un vistazo. La etiqueta y el icono de estado se actualizan automáticamente según los datos del envío.',
    deletable: true,
    defaultSize: 4,
    minSize: 2,
    settingsSections: [
      {
        title: 'Detalles del pedido',
        fields: [
          {
            key: 'show_order_date',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar fecha del pedido',
            helper: 'Muestra la fecha del pedido debajo del número de pedido',
            defaultValue: true,
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.orderItems]: {
    label: 'Items del pedido',
    description:
      'Muestra todos los productos del pedido con su imagen, detalles de la variante, precio y estado actual. Controla qué información del producto ve el cliente final y si puede volver a tu tienda desde ahí.',
    deletable: true,
    defaultSize: 4,
    minSize: 2,
    settingsSections: [
      {
        title: 'Título del bloque',
        fields: [
          {
            key: 'block_title',
            type: blockSettingFieldTypes.translatedText,
            showToggle: true,
            toggleLabel: customPublicNameLabel,
            required: true,
            placeholder: 'Items del pedido',
            defaultValue: {},
          },
        ],
      },
      {
        title: 'Detalles del producto',
        fields: [
          {
            key: 'show_product_image',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar imagen del producto',
            helper: 'Muestra la miniatura del producto en la lista',
            defaultValue: true,
          },
          {
            key: 'show_price',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar precio',
            helper: 'Muestra el precio de cada producto',
            defaultValue: true,
          },
          {
            key: 'show_variant_details',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar detalles de la variante',
            helper: 'Muestra el color y la talla',
            defaultValue: true,
          },
          {
            key: 'show_sku',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar SKU',
            helper: 'Muestra el SKU de cada producto',
            defaultValue: true,
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.returnRequests]: {
    label: 'Solicitud de devolución',
    description:
      'Gestiona la card de llamada a la acción que invita a los clientes a iniciar una devolución o cambio, y la lista de solicitudes de devolución activas con su estado. Cada solicitud enlaza a una página de seguimiento detallada.',
    deletable: true,
    defaultSize: 4,
    minSize: 2,
    settingsSections: [
      {
        title: 'Título del bloque',
        fields: [
          {
            key: 'block_title',
            type: blockSettingFieldTypes.translatedText,
            showToggle: true,
            toggleLabel: customPublicNameLabel,
            required: true,
            placeholder: 'Solicitudes de devolución',
            defaultValue: {},
          },
        ],
      },
      {
        title: 'Detalles de la card de llamada a la acción',
        fields: [
          {
            key: 'cta_message',
            type: blockSettingFieldTypes.translatedText,
            showToggle: true,
            toggleLabel: customMessageLabel,
            required: true,
            label: 'Descripción de la card',
            placeholder: 'Devuelve o cambia tu artículo en pocos pasos.',
            defaultValue: {},
          },
          {
            key: 'cta_button_label',
            type: blockSettingFieldTypes.translatedText,
            showToggle: true,
            toggleLabel: customMessageLabel,
            required: true,
            label: 'Texto del botón',
            placeholder: 'Abrir el portal de devoluciones',
            defaultValue: {},
          },
        ],
      },
      {
        title: 'Detalles de la solicitud',
        fields: [
          {
            key: 'show_request_date',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar fecha de solicitud',
            helper: 'Muestra la fecha de la solicitud debajo del número de devolución',
            defaultValue: true,
          },
          {
            key: 'show_refund_status',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar estado del reembolso',
            helper: 'Muestra el estado y el importe del reembolso o del pago de cada solicitud',
            defaultValue: true,
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.shipments]: {
    label: 'Seguimiento de envío',
    description:
      'Muestra cada envío y devolución del pedido con su estado actual, detalles del subestado y fecha estimada de entrega. Cada elemento enlaza a una vista de seguimiento detallada. Configura qué detalles se muestran en la card resumen.',
    deletable: true,
    defaultSize: 4,
    minSize: 2,
    settingsSections: [
      {
        title: 'Título del bloque',
        fields: [
          {
            key: 'block_title',
            type: blockSettingFieldTypes.translatedText,
            showToggle: true,
            toggleLabel: customPublicNameLabel,
            required: true,
            placeholder: 'Seguimiento de envíos',
            defaultValue: {},
          },
        ],
      },
      {
        title: 'Detalles del envío',
        fields: [
          {
            key: 'show_tracking_status',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar estado de seguimiento',
            helper:
              'Muestra el texto descriptivo del estado de seguimiento (p. ej., «Envío listo - Para recoger en el punto de recogida»)',
            defaultValue: true,
          },
          {
            key: 'show_last_updated',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar última actualización',
            helper: 'Muestra el tiempo transcurrido desde la última actualización del estado',
            defaultValue: true,
          },
          {
            key: 'show_estimated_delivery',
            type: blockSettingFieldTypes.boolean,
            label: 'Mostrar entrega estimada',
            helper: 'Muestra la barra con la fecha estimada de entrega en la parte inferior de cada card',
            defaultValue: true,
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.divider]: { label: 'Divisor', deletable: true, defaultSize: 4, minSize: 1 },
  [trackingPageBlockIds.promotionalBanner]: {
    advanced: true,
    label: 'Banner promocional',
    description:
      'Un bloque visual diseñado para impulsar la recompra: destaca un código de descuento, una campaña de temporada o un mensaje de marca.',
    deletable: true,
    defaultSize: 4,
    minSize: 2,
    supportsVisibility: true,
    aspectRatioSetting: promotionalBannerAspectRatioSetting,
    settingsSections: [
      blockInternalNameSection,
      {
        title: 'Enlace',
        fields: [
          {
            key: 'link_url',
            type: blockSettingFieldTypes.text,
            label: 'URL del enlace',
            helper: 'Hace que todo el banner sea clicable. Déjalo vacío para no añadir enlace.',
            defaultValue: '',
          },
        ],
      },
      {
        title: 'Imagen del banner',
        fields: [
          {
            key: 'image_url',
            type: blockSettingFieldTypes.image,
            label: 'Subir imagen',
            helper: 'Máx. 1MB. Formatos: JPG, JPEG, PNG, HEIC, GIF.',
            accept: 'image/jpeg, image/jpg, image/png, image/heic, image/gif',
            maxSize: 1024,
            defaultValue: '',
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.announcementBar]: {
    advanced: true,
    label: 'Barra de anuncio',
    description:
      'Una franja informativa a todo el ancho que puede colocarse en la cabecera o el pie de la página, ideal para políticas de envío, plazos de devolución o mensajes de temporada.',
    deletable: true,
    defaultSize: 4,
    minSize: 4,
    insertAtTop: true,
    supportsVisibility: true,
    settingsSections: [
      blockInternalNameSection,
      {
        title: 'Texto',
        fields: [
          {
            key: 'text',
            type: blockSettingFieldTypes.translatedText,
            helper: 'Usa | como separador visual entre mensajes',
            placeholder: 'AÑADE TU MENSAJE DE ANUNCIO',
            defaultValue: {},
          },
        ],
      },
      {
        title: 'Enlace',
        fields: [
          {
            key: 'link_url',
            type: blockSettingFieldTypes.text,
            label: 'URL',
            helper: 'Hace que toda la barra sea clicable. Déjalo vacío para no añadir enlace.',
            defaultValue: '',
          },
        ],
      },
      {
        title: 'Estilo',
        fields: [
          {
            key: 'background_color',
            type: blockSettingFieldTypes.color,
            label: 'Color de fondo',
            contrastAgainst: 'text_color',
            defaultValue: '#000000',
          },
          {
            key: 'text_color',
            type: blockSettingFieldTypes.color,
            label: 'Color de texto',
            contrastAgainst: 'background_color',
            defaultValue: '#FFFFFF',
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.customBlock]: {
    advanced: true,
    label: 'Bloque personalizado',
    description:
      'Inserta tu propio HTML en la tracking page: incrusta un widget de fidelización, una encuesta, un feed social o cualquier contenido personalizado. Se renderiza en un iframe aislado (sandbox) por seguridad.',
    deletable: true,
    defaultSize: 4,
    minSize: 1,
    supportsVisibility: true,
    settingsSections: [
      blockInternalNameSection,
      {
        title: 'Contenido HTML',
        fields: [
          {
            key: 'html_content',
            type: blockSettingFieldTypes.textarea,
            helper: 'Se renderiza dentro de un iframe aislado (sandbox)',
            placeholder: 'Pega tu código HTML o de embed',
            rows: 10,
            defaultValue: '',
          },
          {
            key: 'height',
            type: blockSettingFieldTypes.number,
            label: 'Alto del bloque',
            helper: 'Alto en píxeles del contenido embebido',
            min: 80,
            max: 1200,
            defaultValue: 320,
          },
        ],
      },
    ],
  },
  [trackingPageBlockIds.productRecommendations]: {
    advanced: true,
    label: 'Recomendaciones de productos',
    description:
      'Un carrusel de productos que anima a los clientes a descubrir más de tu catálogo. Elígelos manualmente, sácalos de una colección, o deja que Reveni los sugiera automáticamente.',
    deletable: true,
    defaultSize: 4,
    minSize: 2,
    supportsVisibility: true,
    settingsSections: [
      {
        title: 'Título del bloque',
        fields: [
          {
            key: 'block_title',
            type: blockSettingFieldTypes.translatedText,
            showToggle: true,
            toggleLabel: customPublicNameLabel,
            required: true,
            placeholder: 'Encuentra tu próximo favorito',
            defaultValue: {},
          },
          {
            ...internalNameField,
            helper: 'Nombra este bloque para que tu equipo pueda identificarlo. No se muestra al cliente.',
          },
        ],
      },
      {
        title: 'Productos mostrados',
        fields: [
          {
            key: 'max_products',
            type: blockSettingFieldTypes.number,
            label: 'Máximo de productos mostrados',
            helper: 'Número de productos mostrados en el carrusel (3-10)',
            min: 3,
            max: maxRecommendedProducts,
            defaultValue: 6,
          },
          {
            key: 'product_source',
            type: blockSettingFieldTypes.select,
            label: 'Origen de los productos',
            helper:
              'Automático: Reveni sugiere según el pedido. Colección/Categoría: extrae de una colección o categoría de la tienda.',
            options: [
              { value: 'automatic', label: 'Recomendaciones automáticas' },
              { value: 'category', label: 'Productos de una categoría' },
              { value: 'collection', label: 'Productos de una colección' },
            ],
            defaultValue: 'automatic',
          },
          {
            key: 'product_source_value',
            type: blockSettingFieldTypes.select,
            label: 'Categoría',
            optionsSource: blockSettingOptionsSources.productCategories,
            visibleWhen: { key: 'product_source', value: 'category' },
            defaultValue: '',
          },
          {
            key: 'product_source_value',
            type: blockSettingFieldTypes.select,
            label: 'Colección',
            optionsSource: blockSettingOptionsSources.productCollections,
            visibleWhen: { key: 'product_source', value: 'collection' },
            defaultValue: '',
          },
        ],
      },
      {
        title: 'Detalles del producto',
        fields: [
          { key: 'show_price', type: blockSettingFieldTypes.boolean, label: 'Mostrar precio', defaultValue: true },
        ],
      },
    ],
  },
}
